import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Button, F0Dialog } from '@factorialco/f0-react'
import { F0AiChatTextArea, F0OneIcon, useAiChat } from '@factorialco/f0-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useActivity } from 'modules/core/lib/activities/activity'
import { ActivityComponent } from 'modules/core/lib/activities/types'
import i18n from 'modules/core/lib/i18n'

import { useCreateSurvey } from 'modules/engagement_surveys/hooks/useCreateSurvey'

import { getPromptPlaceholders, initialSurveyPrompt } from './prompt'

const CONTAINER_STYLE = { width: '624px' }

const SKIP_BUTTON_STYLE = { bottom: '32px' }

const INPUT_WRAPPER_STYLE = { marginLeft: '-12px', marginRight: '-12px' }

export const CreateSurveyActivity: ActivityComponent = () => {
  const { open, closeActivity } = useActivity()

  const { setPlaceholders, setEnabled } = useAiChat()

  const creating = useRef(false)

  const navigate = useNavigate()

  const { navigation } = useNavigation()

  useEffect(() => {
    setPlaceholders(getPromptPlaceholders())
  }, [setPlaceholders])

  const createSurvey = useCreateSurvey()

  const startFromScratch = async () => {
    if (creating.current) return

    creating.current = true

    const surveyId = await createSurvey()
    if (surveyId) {
      navigate(
        navigation.engagement.smart_surveys.survey.questions.fullPath({
          surveyId: surveyId,
        })
      )
    }
  }

  const handleSend = async (message: string) => {
    if (creating.current)
      return {
        id: '1',
        content: '',
        text: '',
        role: 'user' as const,
      }

    setEnabled(false)
    creating.current = true
    try {
      initialSurveyPrompt.current = message

      const surveyId = await createSurvey()

      if (surveyId) {
        setEnabled(true)
        navigate(
          navigation.engagement.smart_surveys.survey.questions.fullPath({
            surveyId: surveyId,
          })
        )
      }
    } finally {
      setEnabled(true)
      creating.current = false
    }

    return {
      id: '1',
      content: message,
      text: message,
      role: 'user' as const,
    }
  }

  return (
    <F0Dialog isOpen={open} onClose={closeActivity} position="fullscreen">
      <Box justifyContent="center" alignItems="center" height="s600">
        <Box gap="s24" style={CONTAINER_STYLE}>
          <Box gap="s20">
            <F0OneIcon size="lg" spin />
            <Box gap="s8">
              <Text.Header2 className="text-2xl font-semibold">
                {i18n.t('surveys.new_create_survey_modal.title_2')}
              </Text.Header2>
            </Box>
          </Box>
          <Box style={INPUT_WRAPPER_STYLE}>
            <F0AiChatTextArea
              onSend={handleSend}
              inProgress={false}
              submitLabel={i18n.t('surveys.new_create_survey_modal.submit_label')}
            />
          </Box>
        </Box>
      </Box>
      <Box
        position="absolute"
        width="full"
        justifyContent="center"
        alignItems="center"
        style={SKIP_BUTTON_STYLE}
      >
        <F0Button
          label={i18n.t('surveys.new_create_survey_modal.skip_label')}
          onClick={startFromScratch}
          variant="ghost"
        />
      </Box>
    </F0Dialog>
  )
}
